import { renderTooltipJsx } from "datastake-daf/dist/utils";
import styled from "styled-components"

const Style = styled.div`
  position: absolute;
  background: #FFFFFF;
  border: 0.2px solid #EAECF0;
  border-radius: 8px;
  z-index: 2;
  padding: 0 12px;
`;

export default function Tooltip({
  mouseX = 0,
  mouseY = 0,
  t = (s) => s,
  singleSources = 0,
  multipleSources = 0,
}) {
  return (
    <Style style={{ top: mouseY, left: mouseX }}>
      {renderTooltipJsx({
        title: t('Triangulation'),
        items: [
          {
            color: '#227DC0',
            label: t('Single source'),
            value: `${Number(singleSources).toLocaleString('en-us')}%`,
          },
          {
            color: '#8DD5C9',
            label: t('Multiple source'),
            value: `${Number(multipleSources).toLocaleString('en-us')}%`,
          },
        ]
      })}
    </Style>
  )
}

